<div class="row mb-3">
  <div class="col-12">
    <h2 class="mb-3">Contact Details</h2>
    @for (group of contactNumbers().controls; track group; let i = $index) {
      <app-patient-contact-form
        [controlFormGroup]="group"
        [index]="i"
        (delete)="removeContactNumber($event)"
        [deleteEnabled]="contactNumbers().controls.length > 1">
      </app-patient-contact-form>
    }
    <div class="row">
      <div class="col-12 col-md-6">
        <button mat-button color="primary" class="w-100" (click)="addContactNumber()">Add Phone Number</button>
      </div>
    </div>
  </div>
  <mat-divider inset class="w-50"></mat-divider>
  <div class="row">
    <div class="col-12">
      <h2 class="mb-3">Email Address Details</h2>
      @for (group of emailAddresses().controls; track group; let i = $index) {
        <app-patient-email-form
          [controlFormGroup]="group"
          [index]="i"
          (delete)="removeEmailAddress($event)"
          [deleteEnabled]="emailAddresses().controls.length > 1">
        </app-patient-email-form>
      }
      <div class="row">
        <div class="col-12 col-md-6">
          <button mat-button color="primary" class="w-100" (click)="addEmailAddress()">Add Email Address</button>
        </div>
      </div>
    </div>
  </div>
  <mat-divider inset class="w-50"></mat-divider>
  <div class="row">
    <div class="col-12">
      <h2 class="mb-3">Address Details</h2>
      @for (group of addressDetails().controls; track group; let i = $index) {
        <app-patient-address-form
          [controlFormGroup]="group"
          [index]="i"
          (delete)="removeAddress($event)"
          [deleteEnabled]="addressDetails().controls.length > 1">
        </app-patient-address-form>
      }
      <div class="row">
        <div class="col-12 col-md-6">
          <button mat-button color="primary" class="w-100" (click)="addAddress()">Add Address</button>
        </div>
      </div>
    </div>
  </div>
</div>
<mat-divider inset></mat-divider>
<div class="row mb-3">
  <div class="col-sm-12">
    <h2>Secondary Contact Details</h2>
    @for (group of secondaryContacts().controls; track $index; let i = $index) {
      <app-secondary-contact-form
        [index]="i"
        [controlForm]="group"
        [validate]="validate()"
        (delete)="removeSecondaryContact(i)"
        [deleteEnabled]="secondaryContacts().controls.length > 1">
      </app-secondary-contact-form>
    }
    <div class="row">
      <div class="col-12 col-md-6">
        <button mat-button color="primary" class="w-100" (click)="addSecondaryContact()">Add Secondary Contact</button>
      </div>
    </div>
  </div>
</div>
